/* Tassonomia canonica delle tipologie bagno. [sc-48222 / sc-48245]

   ⚠️ Deve restare allineata a `src/scripts/lib/bagno-subcategory.cjs` lato API,
   che è il punto di verità per gli importer: una voce in più qui crea articoli
   con una tipologia che nessun listino produce, una in meno rende invisibili al
   filtro gli articoli che la usano. Vedi SODE api §5.3.2.

   Vive qui e non dentro una pagina perché i consumatori sono due — il filtro e
   la creazione articolo dei listini, e la modale "crea articolo" del preventivo
   — e due copie da tenere allineate a mano sono una di troppo. */

export const BAGNO_SUB_CATEGORIES = [
  "Box Doccia",
  "Rubinetteria",
  "Mobile Bagno",
  "Lavabo",
  "Piano Lavabo",
  "Piatto Doccia",
  "Soffione",
  "Specchio",
  "Sanitario",
  "Doccetta",
  "Braccio Doccia",
  "Colonna Doccia",
  "Presa Acqua",
  "Sifone",
  "Piletta",
  "Set Incasso",
  "Set Box",
  "Flessibile",
  "Flessibile Doccia",
  "Illuminazione",
  "Accessorio Bagno",
  "Accessorio Doccia",
  "Vasca",
  "Pannello Doccia",
  "Asta Doccia",
  "Curva Doccia",
  "Kit Doccia",
  // Tipologie mobili introdotte dal listino Berloni.
  "Top",
  "Base",
  "Base Lavabo",
  "Base Laterale",
  "Pensile",
  "Colonna",
  "Vano Giorno",
  "Mensola",
  "Alzatina",
  "Zoccolo",
  "Idraulica",
  "Kit",
  "Maggiorazione",
];

/** Le stesse voci nella forma { value, label } attesa dai select. */
export const bagnoSubCategoryOptions = () =>
  BAGNO_SUB_CATEGORIES.map((v) => ({ value: v, label: v }));

export default BAGNO_SUB_CATEGORIES;
